var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// EventReporter.ts
import { getArgFromUrl } from './index';
// const baseUrl =
//   process.env.REACT_APP_ENV === 'development'
//     ? 'http://192.168.0.233:9000/api/v1'
//     : 'https://api.danachatapp.com/api/v1'; // 你可以在这里配置公共的 baseURL
var baseUrl = 'http://192.168.0.233:9000/api/v1';
var getUserId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, res, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getArgFromUrl('token');
                return [4 /*yield*/, fetch(baseUrl + '/account/user/getUserInfo', {
                        method: 'POST',
                        headers: {
                            ver: '1.0.18',
                            H5Token: encodeURIComponent("".concat(token)).replace(/%20/g, '%2B'),
                        },
                    })];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.data.uid];
        }
    });
}); };
var EventReporter = /** @class */ (function () {
    function EventReporter(baseUrl, defaultParams, options) {
        if (defaultParams === void 0) { defaultParams = {}; }
        if (options === void 0) { options = {}; }
        this.timers = {}; // 存储计时器
        this.eventQueue = []; // 事件队列
        this.flushTimer = null; // 定时发送计时器
        this.isSending = false; // 是否正在发送
        this.baseUrl = baseUrl;
        this.defaultParams = defaultParams;
        this.userAgent = navigator.userAgent;
        this.token = getArgFromUrl('token') || '';
        this.maxBatchSize = options.maxBatchSize || 10; // 默认10条合并发送
        this.flushInterval = options.flushInterval || 5000; // 默认5秒自动发送
    }
    /**
     * 获取浏览器信息
     */
    EventReporter.prototype.getBrowserInfo = function () {
        var ua = this.userAgent;
        var browserName = '未知';
        var browserVersion = '未知';
        // 检测常见浏览器
        if (ua.indexOf('Chrome') > -1) {
            browserName = 'Chrome';
            browserVersion = ua.match(/Chrome\/([\d.]+)/)[1];
        }
        else if (ua.indexOf('Firefox') > -1) {
            browserName = 'Firefox';
            browserVersion = ua.match(/Firefox\/([\d.]+)/)[1];
        }
        else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
            browserName = 'Safari';
            browserVersion = ua.match(/Version\/([\d.]+)/)[1];
        }
        else if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) {
            browserName = 'IE';
            browserVersion = ua.match(/(MSIE |rv:)([\d.]+)/)[2];
        }
        else if (ua.indexOf('Edge') > -1) {
            browserName = 'Edge';
            browserVersion = ua.match(/Edge\/([\d.]+)/)[1];
        }
        return "".concat(browserName, "/").concat(browserVersion);
    };
    /**
     * 将事件添加到队列
     */
    EventReporter.prototype.addToQueue = function (data) {
        var _this = this;
        // 合并默认参数和传入参数
        var reportData = __assign(__assign(__assign({}, this.defaultParams), data), { time: data.time || Date.now() });
        // 确保必填字段存在
        if (!reportData.event || !reportData.uid) {
            console.error('事件数据不完整', reportData);
            return;
        }
        // 添加原始UA到extra
        if (!reportData.extra) {
            reportData.extra = {};
        }
        reportData.extra.userAgent = this.userAgent;
        // 添加到队列
        this.eventQueue.push(reportData);
        // 如果队列长度达到阈值，立即发送
        if (this.eventQueue.length >= this.maxBatchSize) {
            this.flush();
        }
        else if (!this.flushTimer) {
            // 设置定时器，延迟发送
            this.flushTimer = window.setTimeout(function () { return _this.flush(); }, this.flushInterval);
        }
    };
    /**
     * 发送队列中的所有事件
     */
    EventReporter.prototype.flush = function () {
        return __awaiter(this, void 0, Promise, function () {
            var eventsToSend, response, res, error_1;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 如果队列为空或正在发送，则不执行
                        if (this.eventQueue.length === 0 || this.isSending) {
                            return [2 /*return*/];
                        }
                        // 清除定时器
                        if (this.flushTimer) {
                            clearTimeout(this.flushTimer);
                            this.flushTimer = null;
                        }
                        // 标记为正在发送
                        this.isSending = true;
                        eventsToSend = __spreadArray([], this.eventQueue, true);
                        this.eventQueue = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(this.baseUrl, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    platform: this.getBrowserInfo(),
                                    'user-agent': this.userAgent,
                                    ver: '1.0.18',
                                    H5Token: encodeURIComponent("".concat(this.token)).replace(/%20/g, '%2B'),
                                },
                                body: JSON.stringify(eventsToSend),
                            })];
                    case 2:
                        response = _b.sent();
                        // 重置发送状态
                        this.isSending = false;
                        // 如果队列中又有新事件，继续发送
                        if (this.eventQueue.length > 0) {
                            this.flush();
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        res = _b.sent();
                        return [2 /*return*/, (_a = res.data) === null || _a === void 0 ? void 0 : _a.uid];
                    case 4:
                        error_1 = _b.sent();
                        // 发送失败，将事件放回队列前面
                        this.eventQueue = __spreadArray(__spreadArray([], eventsToSend, true), this.eventQueue, true);
                        this.isSending = false;
                        console.error('上报事件失败:', error_1);
                        // 设置重试定时器
                        if (!this.flushTimer) {
                            this.flushTimer = window.setTimeout(function () { return _this.flush(); }, 3000); // 3秒后重试
                        }
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 上报单个事件（添加到队列）
     */
    EventReporter.prototype.report = function (data) {
        this.addToQueue(data);
    };
    /**
     * 批量上报多个事件（添加到队列）
     */
    EventReporter.prototype.reportBatch = function (dataList) {
        var _this = this;
        dataList.forEach(function (data) { return _this.addToQueue(data); });
    };
    /**
     * 简化版上报方法
     */
    EventReporter.prototype.trackEvent = function (eventName, extra) {
        this.report({
            event: eventName,
            extra: extra,
        });
    };
    EventReporter.prototype.initUserId = function (uid) {
        var _this = this;
        if (uid) {
            this.setUserId(uid);
        }
        else {
            getUserId().then(function (uid) {
                _this.setUserId(uid);
            });
        }
    };
    /**
     * 设置用户ID
     */
    EventReporter.prototype.setUserId = function (uid) {
        this.defaultParams.uid = uid;
    };
    /**
     * 设置默认额外参数
     */
    EventReporter.prototype.setDefaultExtra = function (extra) {
        this.defaultParams.extra = __assign(__assign({}, this.defaultParams.extra), extra);
    };
    /**
     * 开始计时
     * @param label 计时器标签
     * @param reportStart 是否上报开始事件
     */
    EventReporter.prototype.time = function (label, reportStart) {
        if (reportStart === void 0) { reportStart = false; }
        this.timers[label] = Date.now();
        if (reportStart) {
            this.trackEvent("".concat(label, "_start"));
        }
        console.time(label); // 同时使用console.time便于调试
    };
    /**
     * 结束计时并上报
     * @param label 计时器标签
     * @param extra 额外数据
     */
    EventReporter.prototype.timeEnd = function (label, extra) {
        if (!this.timers[label]) {
            console.warn("\u8BA1\u65F6\u5668 \"".concat(label, "\" \u4E0D\u5B58\u5728"));
            return;
        }
        var startTime = this.timers[label];
        var duration = Date.now() - startTime;
        console.timeEnd(label); // 同时使用console.timeEnd便于调试
        // 清除计时器
        delete this.timers[label];
        // 上报持续时间
        this.report({
            event: "".concat(label, "_end"),
            extra: __assign(__assign({}, extra), { duration: duration, duration_seconds: Math.round(duration / 1000), start_time: startTime }),
        });
    };
    /**
     * 获取当前计时器的持续时间（毫秒），不上报
     * @param label 计时器标签
     */
    EventReporter.prototype.getTimeDuration = function (label) {
        if (!this.timers[label]) {
            console.warn("\u8BA1\u65F6\u5668 \"".concat(label, "\" \u4E0D\u5B58\u5728"));
            return null;
        }
        return Date.now() - this.timers[label];
    };
    /**
     * 页面卸载前发送所有待发送的事件
     */
    EventReporter.prototype.registerBeforeUnloadHandler = function () {
        var _this = this;
        window.addEventListener('beforeunload', function () {
            // 使用同步 XMLHttpRequest 发送剩余事件
            if (_this.eventQueue.length > 0) {
                _this.flush();
            }
        });
    };
    return EventReporter;
}());
var reporter = new EventReporter(baseUrl + '/party/popup/saveLog', {
    url: window.location.href.split('?')[0],
});
export default reporter;
